// GAP: no spacing or font-size token for these two design values (top-bar workspace pill).
/** Initial badge edge (design: 18px). */
export const TRIGGER_BADGE_SIZE = "1.125rem";
/** Initial badge letter (design: 10px / 700). */
export const TRIGGER_BADGE_FONT_SIZE = "0.625rem";
